<template>
  <button
    type="button"
    class="h-theme-toggle"
    :aria-pressed="isDark"
    :title="isDark ? 'Switch to light theme' : 'Switch to dark theme'"
    @click="toggle"
  >
    <svg v-if="isDark" viewBox="0 0 24 24" class="h-theme-toggle__i" aria-hidden="true">
      <circle cx="12" cy="12" r="5"/>
      <path d="M12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4"/>
    </svg>
    <svg v-else viewBox="0 0 24 24" class="h-theme-toggle__i" aria-hidden="true">
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/>
    </svg>
    <span class="h-sr">{{ isDark ? 'Light theme' : 'Dark theme' }}</span>
  </button>
</template>

<script>
// Topbar theme toggle — flips useThemeStore, which stamps data-theme on <html>.
import { useThemeStore } from '@root/store/useThemeStore';
import { mapState } from 'pinia';

export default {
  name: 'HermesThemeToggle',
  computed: {
    ...mapState(useThemeStore, ['isDark']),
  },
  methods: {
    toggle() {
      useThemeStore().toggle();
    },
  },
};
</script>

<style scoped>
.h-theme-toggle {
  width: 34px; height: 34px; border: 1px solid var(--h-border-strong, #CBD5E1);
  border-radius: var(--h-radius, 6px); background: var(--h-bg-card, #fff);
  display: flex; align-items: center; justify-content: center;
  color: var(--h-text-secondary, #64748B); cursor: pointer; padding: 0;
}
.h-theme-toggle:hover { color: var(--h-text-primary, #0F172A); border-color: var(--h-border, #E2E8F0); }
.h-theme-toggle:focus-visible { outline: none; box-shadow: var(--h-focus-ring); }
.h-theme-toggle__i { width: 17px; height: 17px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.h-sr { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; border: 0; }
</style>
